webpackJsonp([24],{

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EsignLandingPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _EsignLandingPageFullWidthUploadPanelLayout = __webpack_require__(1445);

var _EsignLandingPageFullWidthUploadPanelLayout2 = _interopRequireDefault(_EsignLandingPageFullWidthUploadPanelLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EsignLandingPage = exports.EsignLandingPage = function (_React$PureComponent) {
  _inherits(EsignLandingPage, _React$PureComponent);

  function EsignLandingPage() {
    _classCallCheck(this, EsignLandingPage);

    return _possibleConstructorReturn(this, (EsignLandingPage.__proto__ || Object.getPrototypeOf(EsignLandingPage)).apply(this, arguments));
  }

  _createClass(EsignLandingPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.Upload.activateUploadButtonById('uploadPDFLarge');
      window.Upload.activateUploadButtonById('uploadPDFLargeMobile');

      // Allow users to upload photos
      window.Upload.photoToPDF.init();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_EsignLandingPageFullWidthUploadPanelLayout2.default, null);
    }
  }]);

  return EsignLandingPage;
}(_react2.default.PureComponent);

EsignLandingPage.defaultProps = {
  layout: 'smallUploadPanel'
};

EsignLandingPage.propTypes = {
  layout: _propTypes2.default.string
};

exports.default = (0, _WithInit2.default)(EsignLandingPage);

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _EsignLandingPage = __webpack_require__(1221);

var _EsignLandingPage2 = _interopRequireDefault(_EsignLandingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.EsignLandingPage = _EsignLandingPage2.default;

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EsignLandingPageBenefitsSection = function EsignLandingPageBenefitsSection(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'large-upload-panel-benefits-list' },
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-benefits-list-row' },
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/pencil-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'Easy to sign - just type, draw, or upload your signature'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/sign-arrow-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'Request signatures from others in seconds'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-benefits-list-row' },
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/share-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'Status updates for you & automatic reminders for your signers'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/printer-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'Secure and encrypted documents with a live audit trail'
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'large-upload-panel-testimonial-wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-testimonial-column no-border-xs' },
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-large-text' },
          '1.2 million'
        ),
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-small-text' },
          'signing users'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-testimonial-column no-border-md' },
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-large-text' },
          '16 million'
        ),
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-small-text' },
          'documents signed'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-testimonial-column press-logo-set' },
        props.isFullWidthUploadPanel ? _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement('img', {
            alt: 'Press Icon TNW',
            className: 'large-upload-panel-testimonial-press-icon tnw-icon',
            src: '/images/tnw-icon.png'
          }),
          _react2.default.createElement('img', {
            alt: 'Press Icon Inc',
            className: 'large-upload-panel-testimonial-press-icon inc-icon',
            src: '/images/inc-icon.png'
          }),
          _react2.default.createElement('img', {
            alt: 'Press Icon Readwrite',
            className: 'large-upload-panel-testimonial-press-icon readwrite-icon',
            src: '/images/readwrite-icon.png'
          }),
          _react2.default.createElement('img', {
            alt: 'Press Icon Huffington Post',
            className: 'large-upload-panel-testimonial-press-icon huff-post-icon',
            src: '/images/huff-post-icon.png'
          })
        ) : _react2.default.createElement('img', {
          alt: 'Press Icons',
          className: 'large-upload-panel-testimonial-press-icons',
          src: '/images/press-logos-set.png'
        })
      )
    )
  );
};

EsignLandingPageBenefitsSection.defaultProps = {
  isFullWidthUploadPanel: false
};

EsignLandingPageBenefitsSection.propTypes = {
  isFullWidthUploadPanel: _propTypes2.default.bool
};

exports.default = EsignLandingPageBenefitsSection;

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EsignLandingPageRadioButtons = __webpack_require__(1447);

var _EsignLandingPageRadioButtons2 = _interopRequireDefault(_EsignLandingPageRadioButtons);

var _EsignLandingPagePhotoToPDFModal = __webpack_require__(1446);

var _EsignLandingPagePhotoToPDFModal2 = _interopRequireDefault(_EsignLandingPagePhotoToPDFModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EsignLandingPageFullWidthUploadPanel = function EsignLandingPageFullWidthUploadPanel(props) {
  return _react2.default.createElement(
    'div',
    { className: 'large-upload-panel-upload-section-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'upload-wrap edit-pages-upload-wrap hide-for-photos' },
      _react2.default.createElement(
        'form',
        { id: 'dropzoneUploader', className: 'uploader' },
        _react2.default.createElement(
          'div',
          { className: 'alert alert-error uploader-error' },
          'Error'
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'uploader-area edit-pages-uploader-area',
            onDrop: function onDrop() {
              window._track('Edit PDF Landing Page', 'Drag and Drop Upload Zone');
            }
          },
          _react2.default.createElement('img', {
            src: '/images/blue-doc-icon.png',
            alt: 'Document and Arrow Icon',
            className: 'large-upload-panel-document-icon'
          }),
          _react2.default.createElement(
            'h3',
            { className: 'large-upload-panel-header' },
            'Drag and Drop Your File Here'
          ),
          _react2.default.createElement(
            'p',
            { className: 'large-upload-panel-sub-header' },
            props.subHeader
          ),
          _react2.default.createElement(
            'a',
            {
              id: 'uploadPDFLarge',
              className: 'btn btn-success large-upload-panel-cta-button'
            },
            'Upload a File to Edit'
          ),
          _react2.default.createElement(_EsignLandingPageRadioButtons2.default, null)
        )
      )
    ),
    _react2.default.createElement(_EsignLandingPagePhotoToPDFModal2.default, null)
  );
};

EsignLandingPageFullWidthUploadPanel.defaultProps = {
  subHeader: 'PDF or Word Document'
};

EsignLandingPageFullWidthUploadPanel.propTypes = {
  subHeader: _propTypes2.default.string
};

exports.default = EsignLandingPageFullWidthUploadPanel;

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EsignLandingPageFullWidthUploadPanel = __webpack_require__(1444);

var _EsignLandingPageFullWidthUploadPanel2 = _interopRequireDefault(_EsignLandingPageFullWidthUploadPanel);

var _EsignLandingPageBenefitsSection = __webpack_require__(1443);

var _EsignLandingPageBenefitsSection2 = _interopRequireDefault(_EsignLandingPageBenefitsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EsignLandingPageFullWidthUploadPanelLayout = function EsignLandingPageFullWidthUploadPanelLayout() {
  return _react2.default.createElement(
    'div',
    { className: 'sem-esign-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'indexRedesign large-upload-panel-wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'container-fluid' },
        _react2.default.createElement(
          'div',
          { className: 'row-fluid' },
          _react2.default.createElement(
            'div',
            { className: 'span12 editor-landing' },
            _react2.default.createElement(
              'div',
              { className: 'large-upload-panel-info-wrapper' },
              _react2.default.createElement(
                'h1',
                { className: 'large-upload-panel-page-header' },
                'eSign Any Document'
              ),
              _react2.default.createElement(
                'h2',
                { className: 'large-upload-panel-page-sub-header' },
                'Sign and send signature requests to anyone, from anywhere - instantly.'
              )
            )
          ),
          _react2.default.createElement(_EsignLandingPageFullWidthUploadPanel2.default, { subHeader: 'PDF, Word Document, Image' })
        ),
        _react2.default.createElement(_EsignLandingPageBenefitsSection2.default, { isFullWidthUploadPanel: true })
      )
    )
  );
};

exports.default = EsignLandingPageFullWidthUploadPanelLayout;

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EsignLandingPagePhotoToPDFModal = function (_React$PureComponent) {
  _inherits(EsignLandingPagePhotoToPDFModal, _React$PureComponent);

  function EsignLandingPagePhotoToPDFModal() {
    _classCallCheck(this, EsignLandingPagePhotoToPDFModal);

    return _possibleConstructorReturn(this, (EsignLandingPagePhotoToPDFModal.__proto__ || Object.getPrototypeOf(EsignLandingPagePhotoToPDFModal)).apply(this, arguments));
  }

  _createClass(EsignLandingPagePhotoToPDFModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'photoToPDF', className: 'hidden centered photoToPDF' },
        _react2.default.createElement(
          'div',
          { id: 'addPages', className: 'btn btn-large btn-custom_info is-big' },
          _react2.default.createElement('input', {
            type: 'file',
            accept: 'application/msword,\n              application/vnd.openxmlformats-officedocument.wordprocessingml.document\n              application/pdf,\n              image/*',
            id: 'selectPhotos',
            name: 'files[]',
            multiple: true
          }),
          'Add Pages ',
          _react2.default.createElement('i', { className: 'icon-camera icon-white' })
        ),
        _react2.default.createElement(
          'button',
          {
            id: 'createPDF',
            onClick: EsignLandingPagePhotoToPDFModal.createPDF,
            className: 'btn btn-large btn-custom_info btn-green is-big create-pdf-from-image-button'
          },
          _react2.default.createElement(
            'span',
            null,
            'Create PDF'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'photo-wrapper' },
          _react2.default.createElement('ul', { id: 'photoList' })
        )
      );
    }
  }], [{
    key: 'createPDF',
    value: function createPDF() {
      window.Upload.photoToPDF.createPDF();
      window._track('create-pdf-from-image', 'edit-pdf page');
    }
  }]);

  return EsignLandingPagePhotoToPDFModal;
}(_react2.default.PureComponent);

exports.default = EsignLandingPagePhotoToPDFModal;

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EsignLandingPageRadioButtons = function (_React$PureComponent) {
  _inherits(EsignLandingPageRadioButtons, _React$PureComponent);

  function EsignLandingPageRadioButtons() {
    _classCallCheck(this, EsignLandingPageRadioButtons);

    return _possibleConstructorReturn(this, (EsignLandingPageRadioButtons.__proto__ || Object.getPrototypeOf(EsignLandingPageRadioButtons)).apply(this, arguments));
  }

  _createClass(EsignLandingPageRadioButtons, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "edit-pages-radio-button-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "edit-pages-radio-button-section" },
          _react2.default.createElement(
            "button",
            {
              className: "edit-pages-radio-button-outer free-write active",
              onClick: function onClick(e) {
                EsignLandingPageRadioButtons.resetUploadDestination(e, 'free-write');
              }
            },
            _react2.default.createElement("div", { className: "edit-pages-radio-button-inner" })
          ),
          _react2.default.createElement(
            "span",
            { className: "edit-pages-radio-button-text" },
            "I want to edit my document only"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "edit-pages-radio-button-section" },
          _react2.default.createElement(
            "button",
            {
              className: "edit-pages-radio-button-outer rearrange",
              onClick: function onClick(e) {
                EsignLandingPageRadioButtons.resetUploadDestination(e, 'rearrange');
              }
            },
            _react2.default.createElement("div", { className: "edit-pages-radio-button-inner" })
          ),
          _react2.default.createElement(
            "span",
            { className: "edit-pages-radio-button-text" },
            "I want to edit my document & rearrange pages"
          )
        )
      );
    }
  }], [{
    key: "resetUploadDestination",
    value: function resetUploadDestination(clickEvent, destination) {
      clickEvent.preventDefault();
      window.Upload.resetUploadDestination(clickEvent, destination);
    }
  }]);

  return EsignLandingPageRadioButtons;
}(_react2.default.PureComponent);

exports.default = EsignLandingPageRadioButtons;

/***/ })

},[1321]);


// WEBPACK FOOTER //
// esign-landing-page.js